import React from 'react'
import { formatDatetime } from '../../lib/utils'
import { tx } from '../../lib/i18n'

interface TimelineItem {
  id: string
  title: string
  description?: string
  timestamp: string
  icon?: React.ReactNode
  color?: string
}

interface TimelineProps {
  items: TimelineItem[]
}

const Timeline: React.FC<TimelineProps> = ({ items }) => {
  if (items.length === 0) {
    return <p className="text-sm text-gray-400 text-center py-4">{tx('No timeline events.')}</p>
  }

  return (
    <ol className="relative space-y-0">
      {items.map((item, idx) => (
        <li key={item.id} className="flex gap-4">
          {/* Line + dot */}
          <div className="flex flex-col items-center">
            <div
              className={`h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0 ${item.color ?? 'bg-indigo-100 text-indigo-600'}`}
            >
              {item.icon ?? (
                <span className="h-2 w-2 rounded-full bg-current" />
              )}
            </div>
            {idx < items.length - 1 && (
              <div className="w-0.5 flex-1 bg-gray-200 my-1" />
            )}
          </div>
          {/* Content */}
          <div className={`pb-5 min-w-0 ${idx < items.length - 1 ? '' : ''}`}>
            <p className="text-sm font-medium text-gray-900">{item.title}</p>
            {item.description && (
              <p className="mt-0.5 text-sm text-gray-500">{item.description}</p>
            )}
            <p className="mt-1 text-xs text-gray-400">{formatDatetime(item.timestamp)}</p>
          </div>
        </li>
      ))}
    </ol>
  )
}

export default Timeline
